import { useCallback, useState } from "react";

import EmployeeWorkInCalendar from "../pages/EmployeeWorkInCalendar";
import EmployeeWorkInLeaveBenefit from "../pages/EmployeeWorkInLeaveBenefit";
import EmployeeWorkInTimestamp from "../pages/EmployeeWorkInTimestamp";
import EmployeeWorkInWorkIn from "../pages/EmployeeWorkInWorkIn";
import EmployeeWorkInWorkInLocation from "../pages/EmployeeWorkInWorkInLocation";

import { EMPLOYEE_WORKIN_PAGE } from "../schemas/employeeWorkInSchema";
import { useSelector } from "react-redux";

function useEmployeeWorkIn() {
  const [selectedMenu, setMenu] = useState(EMPLOYEE_WORKIN_PAGE.TIME_STAMP);

  const workIn = useSelector((state) => state.employee.workIn)

  const getPage = useCallback(() => {
    switch (selectedMenu) {
      case EMPLOYEE_WORKIN_PAGE.TIME_STAMP:
        return <EmployeeWorkInTimestamp />;
      case EMPLOYEE_WORKIN_PAGE.CALENDAR:
        return <EmployeeWorkInCalendar />;
      case EMPLOYEE_WORKIN_PAGE.WORKIN:
        return <EmployeeWorkInWorkIn />;
      case EMPLOYEE_WORKIN_PAGE.WORK_IN_LOCATION:
        return <EmployeeWorkInWorkInLocation />;
      case EMPLOYEE_WORKIN_PAGE.LEAVE_BENEFIT:
        return <EmployeeWorkInLeaveBenefit />;
      default:
        return <div />;
    }
  }, [selectedMenu, workIn]);

  const handleMenuChange = useCallback(
    (e) => {
      setMenu(e);
    },
    [setMenu]
  );

  return {
    getPage,
    handleMenuChange
  };
}

export default useEmployeeWorkIn;
